import { collection, getCountFromServer, query, where } from 'firebase/firestore';
import { db } from '@/lib/firebase';

/**
 * Cuánto trabajo espera en moderación.
 *
 * Existe para una cosa concreta: pintar el punto rojo en "Moderación". Sin él,
 * un pedido de fandom se queda esperando hasta que alguien entre a la solapa
 * por casualidad, y quien lo pidió —que lo pidió porque quería escribir— se va
 * antes de eso.
 *
 * Usa `getCountFromServer`, que trae el número sin bajar los documentos: cuesta
 * una lectura cada mil, no una por pedido. Y sólo se llama para quien es admin,
 * así que en la práctica son dos lecturas por sesión de una sola persona.
 *
 * A propósito NO es en tiempo real. Una escucha abierta sobre dos colecciones
 * gastaría lecturas todo el rato para avisar de algo que no es urgente: un
 * pedido de fandom puede esperar a que se recargue la pantalla.
 */
export interface ModerationQueue {
  fandomRequests: number;
  reports: number;
  total: number;
}

export async function countModerationQueue(): Promise<ModerationQueue> {
  const [requests, reports] = await Promise.all([
    getCountFromServer(
      query(collection(db, 'fandomRequests'), where('status', '==', 'pending')),
    ),
    getCountFromServer(query(collection(db, 'reports'), where('status', '==', 'open'))),
  ]);

  const fandomRequests = requests.data().count;
  const open = reports.data().count;

  return { fandomRequests, reports: open, total: fandomRequests + open };
}
